import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid jkanban-container" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'kanbanBoard',
  setup(__props) {

const defaultDemo = defineAsyncComponent(() => import("@/components/theme/kanbanboard/defaultDemo.vue"))
const customDome = defineAsyncComponent(() => import("@/components/theme/kanbanboard/customDome.vue"))
const apiDome = defineAsyncComponent(() => import("@/components/theme/kanbanboard/apiDome.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Apps",
      title: "Kanban Board"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(defaultDemo)),
        _createVNode(_unref(customDome)),
        _createVNode(_unref(apiDome))
      ])
    ])
  ], 64))
}
}

})